var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"courseB",staticClass:"courseB flex-align-center"},[_c('div',{staticClass:"courseVideo",attrs:{"id":'player'+_vm.itemData.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }